import moment from "moment";

// 缓存素材
export const kCacheAbroadInfos = (jsonStr) => {
    if (jsonStr) {
        const key = 'input-log|' + moment().format('YYYY-MM-DD HH:mm:ss')
        localStorage.setItem(key, jsonStr)
    }
}


// WEBPACK FOOTER //
// ./src/components/mycenter_studyabroad/tool.js